import React from 'react'

import { LntTag } from '@app/components/base'
import { Show } from '@app/components/util'

import { isNullable } from '@app/utils'

import { TAG_TYPE } from '@app/constants/tag'

import styles from './styles.module.scss'

import type { CommentContentProps } from './types'

export const CommentContent: React.FC<CommentContentProps> = ({ samples, message }) => {
  return (
    <>
      <Show condition={ !isNullable(samples) }>
        <div className={ styles.commentContent__samples }>
          { samples?.map(sample => (
            <LntTag
              key={ sample.id }
              type={ TAG_TYPE.primary }
            >
              { sample.message }
            </LntTag>
          )) }
        </div>
      </Show>
      <div className={ styles.commentContent__message }>{ message }</div>
    </>
  )
}
